import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Box } from "@mui/material";
import { useContext } from 'react';
import { useSelector, useDispatch } from "react-redux";
import './treemap.css';
import { color } from "echarts";

///prop---
//  treeMapType: 'SingleColor'(single color with shade) or 'RangeColor'(color based on value range),

export default function Treemap(props) {
  const [minMax,setMinMax] = useState({min: 0, max: 0});
  //add demcimal point as per general  settings for tooltip and data labels both
  const [rangeColor,setRangeColor] = useState([]);


  var optionsguzzlers1= {
        legend: {
            show: true
        },
        chart: {
            type: 'treemap',
            height: '400px',
            toolbar: {
                show: false,
                offsetX: 10,
                offsetY: 0,
                tools: {
                    download: false,
                }
            },
        },
        stroke:{
            show:true,
            width:1.5,
            //colors:[theme === 'dark' ? '#002549' : '#F5F7F6']
            colors:['var(--PrimaryBackground)']
            //colors:['var(--secondary-background)']
        },
        dataLabels: {
            enabled: props.widgetprop.props.extended.dataLabels_enabled,
            //format: "scale", 
            textAnchor: 'middle', 
            formatter: function(text, op) {
                return [text,parseFloat(op.value).toFixed(2)];
            },
            style: {
            fontSize: props.widgetprop.props.extended.fontsize,
            fontFamily:props.widgetprop.props.extended.fonttype,
            fontWeight: props.widgetprop.props.extended.fontweight,
            //colors: undefined
          },
        },
        // tooltip: {
        //   enabled: true,
        //   enabledOnSeries: undefined,
        //   // custom: function({ series, seriesIndex, dataPointIndex, w }) {
        //   //   const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
        //   //   return `<div style="font-weight:600; color:#FFFFFF; background-color:${'#005C8E'};">
        //   //               <span>${data.x}: ${data.y.toFixed(2)}</span>
        //   //           </div>`;
        //   // }, 
        //   custom: undefined,   
        //   hideEmptySeries: true,
        //   fillSeriesColor: false,
        //   theme: false,
        //   borderRadius:0,
        //   style: {
        //     fontSize: '14px',
        //     fontFamily: "Roboto"
        //   },
        //   y: {
        //     formatter: function(value, opts) {
        //       return parseFloat(value).toFixed(2)     
        //     }
        //   },
        // },
        // tooltip: {
        //   enabled: true,
        //   custom: function({ series, seriesIndex, dataPointIndex, w }) {
        //     // Get the hovered data point value
        //     const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
        //     const value = data.y;
        
        //     // Get the color ranges from the configuration
        //     // const colorRanges = w.config.plotOptions.treemap.colorScale.ranges;
            
        //       const treeMapType = props.widgetprop.props.extended.treeMapType;
        //       const singleColor =
        //         props.widgetprop.props.extended.color_scale?.ranges?.[0]?.color || "#EF5350";

        //       const colorRanges = w.config.plotOptions.treemap.colorScale.ranges || [];


        //     // Find the color based on the value range
        //     let color = singleColor; // Default color if no match is found
        //     // Only do range lookup for RangeColor mode
        //     if (treeMapType === "RangeColor") {
        //     for (let i = 0; i < colorRanges.length; i++) {
        //       if (value >= colorRanges[i].from && value <= colorRanges[i].to) {
        //         color = colorRanges[i].color;
        //         break;
        //       }
        //     }
        //   }
        //     return `
        //       <div style="padding: 8px; background-color: #005C8E; color: #FFFFFF; border-radius: 0px 0px 0px 8px; border:0px !important; box-shadow:none !important; outline:none !important;">
        //         <span style="display: inline-block; width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 8px;"></span>
        //         <span style="font-weight:600;">${data.x}: ${data.y.toFixed(2)}</span>
        //       </div>
        //     `;
        //   },
        //   style: {
        //     fontSize: '14px',
        //     fontFamily: "Roboto"
        //   }
        // }, 
        tooltip: {
          enabled: true,
          cssClass:'apexcharts-tooltip',
          style: {
            fontSize: '14px',
            fontFamily: "Roboto"
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value.toFixed(2);
            }
          }
        },          
        colors:[props.widgetprop.props.extended.color_scale.ranges[0].color?props.widgetprop.props.extended.color_scale.ranges[0].color:'#0076f6'],       
        plotOptions: {
            treemap: {
                enableShades: props.widgetprop.props.extended.enableshades,
                shadeIntensity: 0.4,
                borderRadius: 0,
                useFillColorAsStroke: false,
                dataLabels: {
                    enabled: props.widgetprop.props.extended.dataLabels_enabled,
                    format: "truncate",  
                },
                // colorScale: props.widgetprop.props.extended.color_scale
                colorScale: {
                  min: minMax.min,
                  max: minMax.max,
                  ranges: rangeColor
                  
                },
               
              //   colorScale: {
              //     ranges: [  
              //         { from: 0, to: 30, color: '#EF5350' }, // red
              //         { from: 30, to: 60, color: '#81C784' }, // green
              //         { from: 60, to: 90, color: '#80DEEA' }, // lightblue
              //         { from: 90, to: 120, color: '#2196F3' }, // blue
              //         { from: 120, to: 150, color: '#00BCD4' }, // cyan
              //         { from: 150, to: 180, color: '#FFA726' }, // orange
              //         { from: 180, to: 210, color: '#009688' }, // teal
              //         { from: 210, to: 240, color: '#3F51B5' }, // indigo
              //         { from: 240, to: 280, color: '#9C27B0' }  // purple
              //     ],
              //     inverse: false,
              // }
            },
        },
        xaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
    };
    
	  const [options, setOptions] = useState({})
    const [serieschart, setSeriesChart] = useState([])
    const [type, setType] = useState('treemap')
    /*
    useEffect(() => { 
        if(props.widgetprop.type === 'treemap') {
              setOptions(optionsguzzlers1)
              setSeries(guzzlers_yearly)
              setType("treemap")
        }
      },[props.widgetprop])
*/
const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)

    useEffect(()=>{
      var tag_properties = props.widgetprop.props.extended.tagprops;
            var data=[];
            tag_properties.map((charttype)=>{
              if(tagcollectionvalue.hasOwnProperty(charttype.tagid)){
                var sum=0.0
                tagcollectionvalue[charttype.tagid].map((tagvalue)=>{
                    sum = sum + Number(tagvalue.y)
                })
                data.push({x:charttype.displayname, y:sum})
              }
              
            })
            const values = data.map(item => item.y);
            const minValue = values.length ? Math.min(...values) : 0;
            const maxValue = values.length ? Math.max(...values) : 0;
            setMinMax({min: minValue, max: maxValue});
            if(props.widgetprop.props.extended.treeMapType !== undefined) {
              if(props.widgetprop.props.extended.treeMapType === 'RangeColor'){
                setRangeColor(props.widgetprop.props.extended.color_scale.ranges)
              }else if(props.widgetprop.props.extended.treeMapType === 'SingleColor'){
                // setRangeColor([{
                //         "from": minMax.min,
                //         "to": minMax.max,
                //         "color": props.widgetprop.props.extended.color_scale.ranges[0].color?props.widgetprop.props.extended.color_scale.ranges[0].color:'#EF5350'
                // }])
                setRangeColor([])
              }
            }
            var series = [{ data: data}]
            setSeriesChart(series);
    },[props.widgetprop, tagcollectionvalue])

    return(
        <Box sx={{height: '100%',width:'100%',boxSizing:'border-box',padding:'8px'}}>
            <Chart
                options={optionsguzzlers1}
                series={serieschart}
                type={type}
                height="100%"
                width="100%"
            />
        </Box>
    )
}


/*import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Box } from "@mui/material";
import {color_800, color_600, color_400, color_200, color_light, color_dark} from '../../Theme/Colors'
import { useContext } from 'react';
import { ThemeContext } from "../../App";

export default function Treemap(props) {
    const{ theme }= useContext(ThemeContext);

    var chartoptions = {
        legend: {
            show: false
        },
        chart: {
            height: 400,
            type: 'treemap',
            //background: theme === 'dark' ? color_dark.primary_card_bg : color_light.primary_card_bg
        },
        dataLabels: {
            style: {
                colors: ['#FFFFFF']//[theme === 'dark' ? color_light.primary_txt : color_light.primary_txt]
            }
        }
    }
    var seriesdata = [
        {
            data: [
                {
                  x: 'New Delhi',
                  y: 218
                },
                {
                  x: 'Kolkata',
                  y: 149
                },
                {
                  x: 'Mumbai',
                  y: 184
                },
                {
                  x: 'Ahmedabad',
                  y: 55
                },
                {
                  x: 'Bangaluru',
                  y: 84
                },
                {
                  x: 'Pune',
                  y: 31
                },
                {
                  x: 'Chennai',
                  y: 70
                },
                {
                  x: 'Jaipur',
                  y: 30
                },
                {
                  x: 'Surat',
                  y: 44
                },
                {
                  x: 'Hyderabad',
                  y: 68
                },
                {
                  x: 'Lucknow',
                  y: 28
                },
                {
                  x: 'Indore',
                  y: 19
                },
                {
                  x: 'Kanpur',
                  y: 29
                }
              ]
        }
    ]

    var seriesguzzlers= [
        {
          data: [
              { x: 'Chiller', y: 218 }, { x: 'AHU', y: 149 }, { x: 'Boiler', y: 184 }, { x: 'Chiller1',  y: 55 },
              { x: 'AHU1',  y: 84  }, { x: 'Boiler1',  y: 31 },
              {
                  x: 'Chiller2',
                  y: 70
              },
              {
                  x: 'AHU2',
                  y: 30
              },
              {
                  x: 'Boiler2',
                  y: 44
              },
              {
                  x: 'Chiller3',
                  y: 68
              },
              {
                  x: 'AHU3',
                  y: 28
              },
              {
                  x: 'Boiler3',
                  y: 19
              },
              {
                  x: 'Chiller4',
                  y: 29
              }
          ]
      }
    ];
      
    var optionsguzzlers= {
        legend: {
            show: true
        },
        chart: {
            type: 'treemap',
            height: '400px',
            toolbar: {
                show: false,
                offsetX: 0,
                offsetY: 0,
                tools: {
                    download: false,
                }
            },
        },
        /*grid: {
            padding: {
                left: 18,
                right: 0,
            }
        },*
        plotOptions: {
          treemap: {
              enableShades: true,
              shadeIntensity: 0.5,
              useFillColorAsStroke: false,
              dataLabels: {
                enabled: true,
                format: "scale",  
              },
              colorScale: {
                  ranges: [{
                      from: 0,
                      to: 30,
                      color: color_400.red,
                  },
                  {
                    from: 30,
                    to: 60,
                    color: color_400.green,
                  },
                  {
                    from: 60,
                    to: 90,
                    color: color_400.lightblue,
                  },
                  {
                    from: 90,
                    to: 120,
                    color: color_400.blue,
                  },
                  {
                    from: 120,
                    to: 150,
                    color: color_400.cyan,
                  },
                  {
                    from: 150,
                    to: 180,
                    color: color_400.orange,
                  },
                  {
                    from: 180,
                    to: 210,
                    color: color_400.teal,
                  },
                  {
                    from: 210,
                    to: 240,
                    color: color_400.indigo,
                  },
                  {
                    from: 240,
                    to: 280,
                    color: color_400.purple,
                  }
              ],
              inverse: false,
              
              },
          },
        },
    };

    const [options, setOptions] = useState(chartoptions)
    const [series, setSeries] = useState(seriesdata)
    const [type, setType] = useState('treemap')
    
    useEffect(() => { 
        if(props.widgetprop.type === 'treemap') {
              optionsguzzlers.legend.show = props.widgetprop.props.extended.legend.enabled
              optionsguzzlers.chart.height = props.widgetprop.props.basic.height
              optionsguzzlers.plotOptions.treemap.enableShades = props.widgetprop.props.extended.enableShades
              optionsguzzlers.plotOptions.treemap.shadeIntensity = props.widgetprop.props.extended.shadeIntensity
              optionsguzzlers.plotOptions.treemap.dataLabels.format = props.widgetprop.props.extended.dataLabels_format
              optionsguzzlers.plotOptions.treemap.colorScale.inverse =  props.widgetprop.props.extended.inverse_color_range
              setOptions(optionsguzzlers)
              setSeries(seriesguzzlers)
              setType("treemap")
        }
      },[props.widgetprop])

    

    return(
        <Box sx={{height: '100%'}}>
            <Chart
                options={options}
                series={series}
                type={type}
                height="90%"
                width="100%"
            />
        </Box>
    )
}*/